import React, { useEffect, useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { Col, Row, Form, Button, Skeleton, Modal, message } from "antd";
import { CheckOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import queryString from "query-string";
import ClickableTextButton from "components/ClickableTextButton/ClickableTextButton";
import FormInput from "components/FormInput/FormInput";
import FormPasswordInput from "components/FormPasswordInput/FormPasswordInput";
import FormSelection from "components/FormSelection/FormSelection";
import FormGroupSelectionInput from "components/FormGroupSelectionInput/FormGroupSelectionInput";
import ScrollableContainer from "components/ScrollableContainer/ScrollableContainer";
import FormUpload from "components/Upload/FormUpload/FormUpload";
import SectionCard from "components/SectionCard/SectionCard";
import SectionContainer from "components/SectionContainer/SectionContainer";
import Title from "components/Title/Title";
import { LogoContainer } from "pages/Login/Login.styles";
import { withAppContext } from "contexts/AppContext/AppContext";
import { useFetchConstant } from "apis/constant";
import {
  postCreateUser,
  useGetUserById,
  patchUpdateUser,
  deleteUser,
  refetchUser,
  selfSignUpNewUser,
} from "apis/user";
import {
  buildDashboardUri,
  buildLoginUri,
  buildPoliciesUri,
} from "utils/routes";

import {
  DeleteCol,
  RPContainer,
  RPTitle,
  RPDesc,
  RPRequirement,
  SignUpContainer,
} from "./SignUp.styles";
import ReCAPTCHA from "react-google-recaptcha";

// import './keyinput.css';

const { useForm } = Form;
const { success, error, confirm } = Modal;

const User = ({ onLogin }) => {
  const history = useHistory();
  const [form] = useForm();
  const { search } = useLocation();
  const values = queryString.parse(search);

  // const [cssStyle, setCssStyle] = useState('');
  // var keyInput = [
  //   'ArrowUp',
  //   'ArrowDown',
  //   'ArrowUp',
  //   'ArrowDown',
  //   'ArrowLeft',
  //   'ArrowRight',
  //   'ArrowLeft',
  //   'ArrowRight',
  //   'b',
  //   'a'
  // ];

  // var keyEvent = [];

  // useEffect(() => {
  //   const keyDownHandler = (event) => {
  //     console.log('User pressed: ', event.key);

  //     if (event.key) {
  //       keyEvent.push(event.key);

  //       console.log(keyEvent);

  //       setTimeout(() => {
  //         if (keyEvent.length === keyInput.length) {
  //           return keyEvent.every((element, index) => {
  //             if (element === keyInput[index]) {
  //               setTimeout(() => {
  //                 setCssStyle('keyinput');
  //                 setTimeout(() => {
  //                   setCssStyle('');
  //                 }, 2000);
  //               }, 100);
  //             }

  //             return false;
  //           });
  //         }
  //       }, 100);

  //       setTimeout(() => {
  //         console.log('clear');
  //         keyEvent = [];
  //       }, 5000);
  //     }

  //     if (event.key === 'Enter') {
  //       event.preventDefault();

  //       // 👇️ your logic here
  //       // myFunction();
  //     }
  //   };

  //   document.addEventListener('keydown', keyDownHandler);

  //   return () => {};
  // }, []);

  useEffect(() => {
    form.setFieldsValue({
      referral: values?.referral ? values.referral : "",
    });

    return () => {};
  }, []);

  const {
    isLoading: isCountryCodesLoading,
    selection: countryCodes,
  } = useFetchConstant("countries", "phoneCode", "phoneCode");

  const {
    isLoading: isAvailableCountryLoading,
    selection: availableCountry,
  } = useFetchConstant("countries", "name", "name");

  const { isLoading: isRolesLoading, selection: roles } = useFetchConstant(
    "roles"
  );

  const {
    isLoading: isAccountStatusesLoading,
    selection: accountStatuses,
  } = useFetchConstant("accountStatuses");

  const isLoading =
    isAvailableCountryLoading ||
    isCountryCodesLoading ||
    isRolesLoading ||
    isAccountStatusesLoading;
  const pageTitle = "New User";
  const rpTitle = "Password";
  const initialValues = {
    contact: { countryCode: countryCodes[0] && countryCodes[0].value },
  };

  const handleOnSaveButtonClick = async (e) => {
    e.preventDefault();
    try {
      const values = await form.validateFields();

      values.role = "agent_entry";
      values.status = "active";
      console.log("values", values);

      const payload = {
        ...values,
      };

      selfSignUpNewUser(payload)
        .then((createdUser) => {
          Modal.success({
            title: "Register Successful!",
            // okText: "Back to Login",
            okText: "Login now",

            onOk: () => {
              // history.push(buildLoginUri());
              try {
                onLogin(values)
                  .then((response) => {
                    const redirectPath = window.localStorage.getItem(
                      "redirect_path"
                    );
                    if (redirectPath) {
                      history.push(redirectPath);
                      window.localStorage.removeItem("redirect_path");
                    } else {
                      if (response.user.role === "contributor") {
                        history.push(buildPoliciesUri());
                      } else {
                        history.push(buildDashboardUri());
                      }
                    }
                  })
                  .catch((error) => {
                    console.log("Direct login upon sign up error", error);
                  });
              } catch (error) {}
            },
          });
        })
        .catch((ex) => {
          error({
            title: ex.message,
          });
        });
    } catch (error) {
      error.errorFields.forEach((field) => message.error(field.errors[0]));
    }
  };

  return (
    <>
      {isLoading ? (
        <Skeleton active />
      ) : (
        <SignUpContainer>
          <div
            style={{
              position: "absolute",
              left: "calc(50% - (136px / 2))",
              top: "0%",
            }}
            // className={cssStyle}
          >
            <LogoContainer />
          </div>
          {/* <ScrollableContainer> */}
          <Form
            scrollToFirstError
            // onFinish={handleOnSaveButtonClick}
            form={form}
            initialValues={initialValues}
          >
            <Row
              justify="space-between"
              align="middle"
              style={{ marginBottom: "32px" }}
            >
              <ClickableTextButton
                text="Back to Login"
                url={buildLoginUri()}
                showIcon={true}
                type="back"
              />
            </Row>
            <Title marginBottom="32px">{pageTitle}</Title>
            <SectionContainer>
              <SectionCard title="Basic Details">
                <Row gutter={16}>
                  <Col span={12}>
                    <FormInput
                      label="First Name"
                      name={["name", "firstName"]}
                      placeholder="John"
                      requiredErrorMessage="Please enter user's first name."
                    />
                  </Col>
                  <Col span={12}>
                    <FormInput
                      label="Last Name"
                      name={["name", "lastName"]}
                      placeholder="Doe"
                      requiredErrorMessage="Please enter user's last name."
                    />
                  </Col>
                  <Col span={12}>
                    <FormSelection
                      label="Country"
                      name="country"
                      placeholder="Select country"
                      requiredErrorMessage="Please select country."
                      selections={availableCountry}
                    />
                  </Col>
                  <Col span={12}>
                    <FormGroupSelectionInput
                      shouldUpdateField={"contactNumberUpdate"}
                      label="Contact Number"
                      inputName={["contact", "contactNumber"]}
                      selectionName={["contact", "countryCode"]}
                      inputPlaceholder="Contact Number"
                      inputType="number"
                      requiredErrorMessage="Please enter contact number"
                      selections={countryCodes}
                    />
                  </Col>
                  <Col span={12}>
                    <FormInput
                      label="Email Address"
                      name="email"
                      placeholder="your_email@gmail.com"
                      type="email"
                      requiredErrorMessage="Please enter email address"
                    />
                  </Col>
                  <Col span={12}>
                    <FormInput
                      label="Referral"
                      name={"referral"}
                      placeholder="(Optional)"
                    />
                  </Col>
                </Row>
              </SectionCard>
            </SectionContainer>
            <SectionContainer>
              <SectionCard title="Company Details">
                <Row gutter={16}>
                  <Col span={12}>
                    <FormInput
                      label="Company Name"
                      name={["company", "name"]}
                      requiredErrorMessage="Please enter your company name."
                    />
                  </Col>
                  <Col span={12}>
                    <FormUpload
                      label="Company Logo"
                      name={["company", "logo"]}
                      acceptTypes={["image/*"]}
                      isDisplayCard
                      labelButtonUpload="Upload"
                      fileSizeLimitInMb={1}
                      tooltipMessage="Use square size logo. Best size: 128px * 128px"
                    />
                  </Col>
                </Row>
              </SectionCard>
            </SectionContainer>
            <SectionContainer>
              <SectionCard title="Account Details">
                <Row gutter={8}>
                  <Col span={12}>
                    <FormInput
                      label="Username"
                      name="username"
                      placeholder="username123"
                      requiredErrorMessage="Please enter user's username."
                    />
                    {/* <FormSelection
                        label="Role"
                        name="role"
                        placeholder="Select role type"
                        requiredErrorMessage="Please select type of role."
                        selections={roles}
                      /> */}
                    {/* <FormSelection
                      label="Status"
                      name="status"
                      placeholder="Select account status"
                      requiredErrorMessage="Please select account status."
                      selections={accountStatuses}
                    /> */}
                  </Col>
                  <Col span={12}>
                    <RPContainer>
                      <RPTitle>{rpTitle}</RPTitle>
                      <RPDesc>
                        This password will be used for logging in. Users can
                        self-reset their password in user profile page.
                      </RPDesc>
                      <RPRequirement>
                        Use alphanumeric and at least 1 uppercase letter for a
                        length of 12 - 20 characters
                      </RPRequirement>
                      <FormPasswordInput
                        name="password"
                        placeholder="P@ssW0rd"
                        requiredErrorMessage={"Please enter user's password."}
                        checkPattern={true}
                      />
                    </RPContainer>
                  </Col>
                </Row>
                <Row gutter={8}>
                  <Form.Item
                    hasFeedback
                    name="reCaptcha"
                    rules={[
                      {
                        required: true,
                        message: "Recaptcha is required",
                      },
                    ]}
                  >
                    <ReCAPTCHA
                      style={{ marginLeft: 8 }}
                      sitekey="6LcTRr0eAAAAANsQsmNk4yqAP4_jcIFq1j0L2YUR"
                      onChange={(e) => {
                        console.log(e);
                      }}
                    />
                  </Form.Item>
                </Row>
              </SectionCard>
            </SectionContainer>

            <Row justify="end" align="middle">
              <Col>
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<CheckOutlined />}
                  onClick={handleOnSaveButtonClick}
                >
                  Register
                </Button>
              </Col>
            </Row>
          </Form>
          {/* </ScrollableContainer> */}
        </SignUpContainer>
      )}
    </>
  );
};

export default withAppContext(User);
